import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { chevronLeft } from 'assets/icon';
import { ImageView, TextView } from 'components';
import { TypographyWeight } from 'components/TextView/TextView';
import useAmplitude from 'hooks/useAmplitude';

interface BackButtonWithHeadingProps {
  iconSize?: number;
  text: string;
  textSize?: number;
  textWeight?: TypographyWeight;
  color?: string;
  style?: React.CSSProperties;
  eventData?: { eventName: string; payload: object };
}

const BackButtonWithHeading: FC<BackButtonWithHeadingProps> = ({
  iconSize = 24, // Default icon size
  text,
  textSize = 24, // Default text size
  textWeight = 'bold', // Default weight
  color = '#101828', // Default color
  style,
  eventData,
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();

  const handleBackClick = () => {
    if (eventData) {
      trackEvent(eventData.eventName, eventData.payload);
    }

    const referrerPath = sessionStorage.getItem('missedCallsReferrer');
    if (referrerPath) {
      sessionStorage.removeItem('missedCallsReferrer');
      navigate(referrerPath);
    } else {
      navigate(-1);
    }
  };
  return (
    <div
      className={`flex items-center cursor-pointer -ml-2 gap-0.5`}
      onClick={() => {
        if (['Allocation list', 'Welcome to Yucollect'].includes(text)) return;
        handleBackClick();
      }}
      style={style}
    >
      {/* <IconView iconName="chevron-left" size={iconSize} /> */}
      {!['Allocation list', 'Welcome to Yucollect'].includes(text) && (
        <ImageView src={chevronLeft} className="mr-2" />
      )}
      <TextView
        text={text}
        size={textSize}
        lineHeight={36}
        weight={textWeight}
        color={color}
      />
    </div>
  );
};

export default BackButtonWithHeading;
